import React from 'react';

/**
 * Creates a lazy-loaded version of a component
 * @param Component The component to lazy load
 * @returns A lazy-loaded component
 */
export const createLazyComponent = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const LazyComponent = (props: P) => {
    const [LoadedComponent, setLoadedComponent] = 
      React.useState<React.ComponentType<P> | null>(null);
    
    React.useEffect(() => {
      setLoadedComponent(() => Component);
    }, []);
    
    return LoadedComponent ? <LoadedComponent {...props} /> : null;
  };
  
  return LazyComponent;
}; 